import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

const useHasAccess = () => {
  const { customerUser } = useSelector((state: RootState) => state.user);

  const accessLevel: number = useMemo(() => {
    if (!customerUser) return 10;
    if (customerUser.customerPositionTitle === 'مدیر') return 0;
    if (customerUser.customerPositionTitle === 'معاون') return 1;
    if (customerUser.customerPositionTitle === 'رئیس') return 2;
    if (customerUser.customerPositionTitle === 'رابط') return 3;
    if (customerUser.customerPositionTitle === 'کارشناس') return 4;
    if (customerUser.customerPositionTitle === 'اپراتور') return 5;

    return 10;
  }, [customerUser]);

  const hasAccessLevel = (accessNeeded: number) => {
    return accessLevel <= accessNeeded;
  };
  return hasAccessLevel;
};

export default useHasAccess;
